'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _useAssetUpload = require('./useAssetUpload');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_useAssetUpload).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }